export default __webpack_public_path__ + "static/play-btn-f7ed4b92ed7b8e266e7557cf31bbad13.svg";